import React from 'react'

// components
import {
  CRow
} from '@coreui/react-pro'
import AppTextColumnDetails from '../general-details/AppTextColumnDetails'

const AppDetails = ({
  timeOffBalanceDetails,
}) => {
  return (
    <>
      <CRow className="m-4 p-3 bg-light border rounded">
        <AppTextColumnDetails
          colSize="4"
          title={<span className="fs-5 fw-bold">Balance Accrued</span>}
          subtitle={<span className="fs-5 fw-bold">{timeOffBalanceDetails?.summary?.accrued_balance ? `${timeOffBalanceDetails?.summary?.accrued_balance} Days` : '0 Days'}</span>}
          className="text-center border-end"
        />
        <AppTextColumnDetails
          colSize="4"
          title={<span className="fs-5 fw-bold">Balance Used</span>}
          subtitle={<span className="fs-5 fw-bold text-danger">{timeOffBalanceDetails?.summary?.used_balance ? `${timeOffBalanceDetails?.summary?.used_balance} Days` : '0 Days'}</span>}
          className="text-center border-end"
        />
        <AppTextColumnDetails
          colSize="4"
          title={<span className="fs-5 fw-bold">Balance Available</span>}
          subtitle={
            <div className="d-flex flex-column align-items-center">
              <span className="fs-5 fw-bold text-success">{timeOffBalanceDetails?.summary?.available_balance ? `${timeOffBalanceDetails?.summary?.available_balance} Days` : '0 Days'}</span>
              <span className="text-secondary" style={{ fontSize: "12px" }}>Annual leave allowance valid until 31 December {new Date().getFullYear()}</span>
            </div>
          }
          className="text-center"
        />
      </CRow>
      <CRow className="m-4 p-3 bg-light border rounded">
        <AppTextColumnDetails
          colSize="4"
          title={<span className="fs-5 fw-bold">Employee ID</span>}
          subtitle={timeOffBalanceDetails?.employee?.id ? timeOffBalanceDetails?.employee?.id : '-'}
          className="text-center"
        />
        <AppTextColumnDetails
          colSize="4"
          title={<span className="fs-5 fw-bold">Employee Name</span>}
          subtitle={timeOffBalanceDetails?.employee?.name ? timeOffBalanceDetails?.employee?.name : '-'}
          className="text-center"
        />
        <AppTextColumnDetails
          colSize="4"
          title={<span className="fs-5 fw-bold">Employee Status</span>}
          subtitle={timeOffBalanceDetails?.employee?.status ? timeOffBalanceDetails?.employee?.status : '-'}
          className="text-center"
        />
      </CRow>
      <CRow className="m-4 p-3 bg-light border rounded">
        {
          timeOffBalanceDetails?.policy_summary?.map((item, index) => {
            return (
              <AppTextColumnDetails
                key={index}
                colSize="3"
                title={item?.name ? item?.name : '-'}
                subtitle={item?.request_count ? `${item?.request_count} Requests` : '0 Requests'}
                className="text-center"
              />
            )
          })
        }
      </CRow>
    </>
  )
}

export default AppDetails
